<template>
    <div>
      <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0 bg-blue">
          <b-navbar-toggle target="nav_collapse_actions"></b-navbar-toggle>
          <h1 class="text-center navbar-brand pt-0 pb-0 mb-0 my-2">Encuesta de satisfacción</h1>
          <b-collapse is-nav id="nav_collapse_actions" >
            <b-navbar-nav class="ml-auto">
              <!--select v-if="sedesPosibles" v-model="sedes" class="form-control" multiple>
                <option disabled value="">---SIN SALON---</option>
                <option v-for="opcion in sedesPosibles"
                :value="opcion.id">{{ opcion.nombre}}</option>
              </select-->
              


            </b-navbar-nav>
            <b-navbar-nav  class="ml-auto">
              
            </b-navbar-nav>
          </b-collapse>
      </b-navbar>
  
        <div class="container-fluid" >
          <b-row >
            <b-col cols="12">
              <b-row>
                <b-col cols="12" sm="4" md="3" class="mt-2">
                  <b-form-group id="input-group-tipo" label="Tipo:" label-for="input-sede">
                    <select v-model="tipo" class="form-control">
                      <option v-for="opcion in tiposPosibles"
                      :value="opcion.id">{{ opcion.nombre}}</option>
                    </select>
                  </b-form-group>
                </b-col>
                  <b-col cols="12" sm="4" md="3" class="mt-2">
                    <b-form-group id="input-group-sede" label="Sede clase:" label-for="input-sede">
                      <multiselect
                        v-model="sedes"
                        :multiple="true"
                        :close-on-select="false"
                        label="nombre"
                        track-by="id"
                        :options="sedesPosibles">
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="4" md="3" class="mt-2">
                    <b-form-group id="input-group-fecha" label="Fecha encuesta:" label-for="input-fecha">
                      <date-picker  class="date-picker" v-model="intervalo" lang="es" type="date" 
                      :time-picker-options="timePickerOptions" range confirm :clearable="true"></date-picker>
                    </b-form-group>
                  </b-col>
                  
                  <!-- b-col cols="12" sm="4" md="3" class="mt-2">
                    <b-form-group id="input-group-documento" label="Documento de estudiante:" label-for="input-documento" description="Número de documento del estudiante">                    
                      <b-form-input v-model="numero_documento" placeholder="Número de documento"></b-form-input>
                    </b-form-group>
                  </b-col-->
                  <b-col cols="12" sm="4" md="3" class="py-4">     
                    <b-btn class="mt-3" variant="outline-primary" @click="generarReporte">
                      Consultar
                    </b-btn>
                    <b-btn class="mt-3 ml-2" variant="outline-warning" :disabled="!registros || registros && !registros.length">                    
                      <download-excel 
                          :data="registros"
                          :fields="json_fields"
                          worksheet="Encuesta Satisfaccion"
                          name="encuesta_satisfaccion.xls">
                          Descargar
                      </download-excel>
                    </b-btn>
                  </b-col>
                </b-row>
            </b-col>
            <b-col cols="12">  
              <div class="reporte_dia table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Fecha</th>
                      <th scope="col">Hora</th>
                      <th scope="col">Sede Estudiante</th>
                      <th scope="col">Estudiante</th>
                      <th scope="col">Tipo de documento</th>
                      <th scope="col">Número de documento</th>
                      <th scope="col">Número de celular</th>
                      <th scope="col">Correo electrónico</th>
                      <th scope="col">Docente</th>
                      <th scope="col">Sede Clase</th>
                      <th scope="col">Salon</th>
                      <th scope="col">Tema</th>
                      <th scope="col">Calificación</th>
                      <th scope="col">Comentarios</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in registros">
                      <td>{{presentDate(item.fecha)}}</td>
                      <td>{{item.hora}}</td>
                      <td>{{item.estudiante.sede_original && item.estudiante.sede_original.nombre ? item.estudiante.sede_original.nombre : '' }}</td>
                      <td>{{item.estudiante.primer_nombre+' '+item.estudiante.segundo_nombre+' '+item.estudiante.primer_apellido+' '+item.estudiante.segundo_apellido}}</td>
                      <td>{{item.estudiante.tipo_documento}}</td>
                      <td>{{item.estudiante.numero_documento}}</td>
                      <td>{{item.estudiante.movil}}</td>
                      <td>{{item.estudiante.email}}</td>
                      <td>{{item.docente.primer_nombre+' '+item.docente.segundo_nombre+' '+item.docente.primer_apellido+' '+item.docente.segundo_apellido}}</td>
                      <td>{{item.salon.sede.nombre}}</td>
                      <td>{{item.salon.nombre}}</td>
                      <td>{{item.tema_nombre}}</td>
                      <td>{{item.calificacion}}</td>
                      <td>{{item.comentarios}}</td>
                    </tr>
                  </tbody>
                </table>
              </div> 

            </b-col>
          </b-row>
      </div>
        
    </div>
  </template>
  
  <script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
    import Vue from 'vue';
    import DatePicker from 'vue2-datepicker'
    import Multiselect from 'vue-multiselect'
  
    export default {
      name: 'ReporteEncuesta',
      components: {
        DatePicker,
        Multiselect
      },
      data () {
        return {
            intervalo:[],
            sedes:[],
            tipo:"clase",
            registros: [],
            tiposPosibles:[{id:"clase",nombre:"Clase"},{id:"tutoria",nombre:"Tutoria"}],
            timePickerOptions:{    
            },
            json_fields: {
              "Fecha":"fecha",
              "Hora":"hora",
              "Sede":{
                callback: (value) => {
                  return value.estudiante.sede_original && value.estudiante.sede_original.nombre ? value.estudiante.sede_original.nombre : '';
                }
              },
              "Estudiante": {
                callback: (value) => {
                  return `${value.estudiante.primer_nombre} ${value.estudiante.segundo_nombre} ${value.estudiante.primer_apellido} ${value.estudiante.segundo_apellido}`;
                }
              },
              "Tipo de documento":"estudiante.tipo_documento",
              "Número de documento":"estudiante.numero_documento",
              "Número de celular":"estudiante.movil",
              "Correo electrónico":"estudiante.email",
              "Docente":{
                callback: (value) => {
                  return `${value.docente.primer_nombre} ${value.docente.segundo_nombre} ${value.docente.primer_apellido} ${value.docente.segundo_apellido}`;
                }
              },
              "Sede":"salon.sede.nombre",
              "Salon":"salon.nombre",
              "Tema":"tema_nombre",
              "Calificación":"calificacion",
              "Comentarios":"comentarios",
            }
        }
      },
      mounted () {
        if(!this.todasLasSedes || (this.todasLasSedes && this.todasLasSedes.length==0)){
          this.fetchSedes().finally(() => {
            this.establecerSede();
          })
        } else {
          this.establecerSede();
        }
      },
      methods:{
        ...mapActions({
          fetchSedes: 'sedes/fetchLista',
        }),
        ...mapMutations({
          startProcessing: 'startProcessing',
          stopProcessing: 'stopProcessing'
        }),
        establecerSede() {
          if (this.sedesPosibles.length == 1) {
            this.sedes.push(this.sedesPosibles[0])
          }  
        },
        generarReporte(){
          console.log('Generando reporte....')
          this.startProcessing()
          Vue.http.post('reportes/encuesta-satisfaccion',{
            fecha_inicio:this.$moment(this.intervalo[0]).format('YYYY-MM-DD'),
            fecha_fin:this.$moment(this.intervalo[1]).format('YYYY-MM-DD'),
            sedes:this.sedes.map(x => x.id),//this.sedes,
            tipo:this.tipo
          }).then(
            response =>{
              this.registros = response.data;
            }
          ).catch(error=>{
            console.log(error)
          }).finally(()=>{
            this.stopProcessing()
          })
        },
        presentDate(value){
          if (value) {
            return this.$moment(value).format('DD/MM/YYYY')
          }
          return '';
        },
        getIdioma(item) {
          if (item.cursoAnterior) {
            return item.cursoAnterior ? (item.cursoAnterior.codigo.indexOf('EN') > -1 ? 'Inglés' : 'Frances') : '';
          } else if (item.cursoNuevo) {
            return item.cursoNuevo ? (item.cursoNuevo.codigo.indexOf('EN') > -1 ? 'Inglés' : 'Frances') : '';
          }
          return '';
        },
      },
      computed: {
        ...mapState({
          user: state => state.auth.user, 
          todasLasSedes: state  => state.sedes.lista,         
        }),
        ...mapGetters({
          permiso: 'auth/permiso', 
        }),
        sedesPosibles(){
          if(this.user && this.user.data && this.user.data.sedes_permitidas && this.user.data.sedes_permitidas.length>0){
            return this.todasLasSedes.filter(element=>{
              return this.user.data.sedes_permitidas.includes(element.id) 
            })
          }
          return false
        },
        puedeCambiarSede(){
          return this.permiso('2E3F932E')
        },

      }
    }
  </script>
  
  <style scope>
  
  .date-picker{
    
  }
  </style>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>